module.exports = __webpack_public_path__ + "media/audio19.a85e15f6.mp3";